import { IProductsRaw } from '~/assets/interfaces/products'

export function componentNameProducts(
  products: IProductsRaw | null,
  isMobile: boolean
): string | undefined {
  if (!products) {
    return undefined
  }
  if (products.type === 'table') {
    return 'component-product-item-1'
  }
  return isMobile
    ? 'component-mobile-product-item-3'
    : 'component-product-item-3'
}
